export const STAFF_ORIGIN = 'https://staff.poutaesthetics.co.uk';
let registrationPromise;
let installPrompt;
window.addEventListener('beforeinstallprompt', (event) => {
  if (!isStaffOrigin()) return;
  event.preventDefault(); installPrompt = event;
  window.dispatchEvent(new Event('pout-install-ready'));
});
export function canInstall() { return Boolean(installPrompt); }
export async function installStaffApp() {
  if (!installPrompt) return false;
  await installPrompt.prompt();
  const choice = await installPrompt.userChoice;
  installPrompt = null;
  return choice.outcome === 'accepted';
}
export async function pushRequest(path, body) {
  const token = localStorage.getItem('pout.staff.token');
  const response = await fetch('/api/staff/push/' + path, {
    method: body === undefined ? 'GET' : 'POST', cache: 'no-store',
    headers: {'Content-Type': 'application/json', Authorization: `Bearer ${token || ''}`},
    ...(body === undefined ? {} : {body: JSON.stringify(body)}),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Notifications could not be updated. Please try again.');
  return data;
}
export async function disableStaffPush() {
  if (!isStaffOrigin() || !('serviceWorker' in navigator)) return;
  const registration = await navigator.serviceWorker.getRegistration('/staff');
  const subscription = await registration?.pushManager?.getSubscription();
  if (!subscription) return;
  // Revoking at the browser also prevents delivery if the server is unreachable.
  let serverError;
  try { await pushRequest('unsubscribe', {endpoint: subscription.endpoint}); } catch (error) { serverError = error; }
  const revoked = await subscription.unsubscribe();
  if (!revoked && serverError) throw serverError;
}
export function isStaffOrigin() { return window.location.origin === STAFF_ORIGIN; }
export function registerStaffPwa() {
  if (!isStaffOrigin() || !('serviceWorker' in navigator)) return Promise.resolve(null);
  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker.register('/staff-worker.js', {scope: '/staff', updateViaCache: 'none'})
      .catch((error) => { registrationPromise = null; throw error; });
  }
  return registrationPromise;
}
export function initialiseStaffPwa() {
  if (!isStaffOrigin()) return;
  const manifest = document.createElement('link');
  manifest.rel = 'manifest'; manifest.href = '/staff-manifest.json'; document.head.appendChild(manifest);
  const icon = document.createElement('link');
  icon.rel = 'apple-touch-icon'; icon.href = '/brand/pout-logo.png'; document.head.appendChild(icon);
  document.title = 'Pout Staff';
  registerStaffPwa().catch(() => { /* Installation page offers a visible retry. */ });
}
